const months = {
  0: 'Jan',
  1: 'Feb',
  2: 'Mar',
  3: 'Apr',
  4: 'May',
  5: 'Jun',
  6: 'Jul',
  7: 'Aug',
  8: 'Sep',
  9: 'Oct',
  10: 'Nov',
  11: 'Dec'
};

const dayNames = {
  0: 'Sun',
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat'
};

const fullDayNames = {
  0: 'Sunday',
  1: 'Monday',
  2: 'Tuesday',
  3: 'Wednesday',
  4: 'Thursday',
  5: 'Friday',
  6: 'Saturday'
};

const fullMonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

const getDatesRange = (from = 0, to = 6) => {
  const startDate = new Date();
  const nextWeek = [];
  const step = (from <= to) ? 1 : -1;
  const condition = (i, limit) => ((from <= to) ? i <= limit : i >= limit);
  for (let i = from; condition(i, to); i += step) {
    const currentDate = new Date();
    currentDate.setDate(startDate.getDate() + i);
    nextWeek.push({
      dayNumber: currentDate.getDate(),
      dayName: i === 0 ? 'Today' : dayNames[currentDate.getDay()],
      month: months[currentDate.getMonth()],
      fullDayName: fullDayNames[currentDate.getDay()],
      fullMonthName: fullMonthNames[currentDate.getMonth()],
      year: currentDate.getFullYear()
    });
  }

  return nextWeek;
};

export default getDatesRange;
